import { useNavigate } from "react-router";
import { OperioBrand } from "~/ui/brand/OperioBrand";

export function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-6 sm:px-6">
          <div className="flex items-center justify-between">
            <OperioBrand subtitle="Rechnungsverwaltung für Dienstleister" />
            <button
              onClick={() => navigate("/login")}
              className="rounded-md bg-blue-600 px-6 py-2 font-medium text-white hover:bg-blue-700"
            >
              Login
            </button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 md:py-24">
        <div className="text-center">
          <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
            Rechnungsverwaltung. Einfach gemacht.
          </h2>
          <p className="mb-8 text-xl text-gray-600">
            Operio hilft Dienstleistern, ihre Rechnungen und Kundendaten in der
            Cloud zu verwalten. Von Baumfällern über Handwerker bis zu
            Freiberuflern — für alle geeignet.
          </p>
          <button
            onClick={() => navigate("/login")}
            className="rounded-md bg-blue-600 px-8 py-3 text-lg font-medium text-white hover:bg-blue-700"
          >
            Jetzt anmelden
          </button>
        </div>
      </section>

      {/* Features */}
      <section className="bg-gray-50 py-16 sm:py-24">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <h3 className="mb-12 text-center text-3xl font-bold text-gray-900">
            Was Operio kann
          </h3>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            <Feature
              icon="👥"
              title="Kundenverwaltung"
              description="Speichere Kundendaten zentral. Alle Informationen sind sofort verfügbar."
            />
            <Feature
              icon="📄"
              title="Rechnungen erstellen"
              description="Erstelle schnell und einfach professionelle Rechnungen mit automatischer Nummerierung."
            />
            <Feature
              icon="💰"
              title="Zahlungserfassung"
              description="Verfolge Ein- und Ausgänge. Sehe auf einen Blick, was bezahlt ist."
            />
            <Feature
              icon="📊"
              title="Steuersummary"
              description="Generiere automatisch Jahres- und Quartalsberichte für deine Steuer."
            />
            <Feature
              icon="📱"
              title="Cloud-basiert"
              description="Arbeite von überall. Keine Installation, keine Updates nötig."
            />
            <Feature
              icon="🔒"
              title="Sicher & Privat"
              description="Deine Daten sind verschlüsselt und auf europäischen Servern gespeichert."
            />
          </div>
        </div>
      </section>

      {/* Pricing / CTA */}
      <section className="mx-auto max-w-6xl px-4 py-16 text-center sm:px-6 md:py-24">
        <h3 className="mb-4 text-3xl font-bold text-gray-900">
          Bereit loszulegen?
        </h3>
        <p className="mb-8 text-lg text-gray-600">
          Schreibe uns eine E-Mail und wir richten ein Konto für dich ein.
        </p>
        <a
          href="mailto:kontakt@altibo.de?subject=Operio%20Konto%20anfordern&body=Hallo,%0Aich%20interessiere%20mich%20für%20Operio."
          className="inline-block rounded-md bg-blue-600 px-8 py-3 font-medium text-white hover:bg-blue-700"
        >
          Konto anfordern
        </a>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50 py-8">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <div className="text-sm text-gray-600">
              © 2026 ALTIBO. Operio ist ein Produkt von Alexander Bolz.
            </div>
            <div className="flex gap-6 text-sm">
              <a
                href="/impressum"
                className="text-blue-600 hover:text-blue-700"
              >
                Impressum
              </a>
              <a
                href="/datenschutz"
                className="text-blue-600 hover:text-blue-700"
              >
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

function Feature({
  icon,
  title,
  description,
}: {
  icon: string;
  title: string;
  description: string;
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <div className="mb-4 text-4xl">{icon}</div>
      <h4 className="mb-2 text-lg font-semibold text-gray-900">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
}
